import { useSuspenseQuery } from '@tanstack/react-query';
import type { Account } from '../types';
import queryKeys from './queryKeys';
import type { QueryConfig } from 'lib/react-query';
import { apiClient } from 'lib/api';

interface GetAccountDetailsParams {
  id: number;
}

export const getAccountDetails = async (
  params: GetAccountDetailsParams,
  signal?: AbortSignal,
): Promise<Account> => {
  const res = await apiClient.get<Account>(
    `${queryKeys.accounts}/${params.id}`,
    { signal },
  );
  return res.data;
};

interface UseAccountDetailsOptions<TData> {
  config?: QueryConfig<typeof getAccountDetails, TData>;
  params: GetAccountDetailsParams;
}

export const useAccountDetails = <TData = Account>
({
   params,
   config,
 }: UseAccountDetailsOptions<TData>) => {
  return useSuspenseQuery({
    staleTime: 60 * 30 * 1000,
    ...config,
    queryFn: ({ signal }) => getAccountDetails(params, signal),
    queryKey: [queryKeys.accountsDetails, params],
  });
};
